import React from 'react';
import { styled } from '@compiled/react';
import Button, { type ButtonProps } from '@atlaskit/button';
import { Box, Flex, Inline, xcss, Text } from '@atlaskit/primitives';
import type { SupportedThirdParty } from '../../../../common/constants/import-type';
import { useContentForThirdParty } from '../../../../common/utils/content-for-third-party';
import { StatusTable } from './status-table';

type StatusMappingContentProps = {
	thirdParty: SupportedThirdParty;
	onEntityChanged: (entity: string) => void;
	entities: string[];
	selectedEntityTab: string | null;
};

export const StatusMappingContent = ({
	thirdParty,
	onEntityChanged,
	entities,
	selectedEntityTab,
}: StatusMappingContentProps) => {
	const { statusMappingEntityName } = useContentForThirdParty(thirdParty);

	return (
		<>
			{entities.length > 1 && (
				<Inline
					space="space.100"
					xcss={tabHeaderStyles}
					grow="fill"
					spread="space-between"
					shouldWrap
					rowSpace="space.150"
					testId="project-create-importer-upload-flow.ui.third-party-review-screen.status-mapping.status-mapping-content.status-mapping-content-tab-header"
				>
					<Flex alignItems="center" gap="space.100" xcss={tabContentStyles}>
						{statusMappingEntityName && (
							<Box xcss={textStyles}>
								<Text align="center">{statusMappingEntityName}</Text>
							</Box>
						)}
						<Flex gap="space.100" xcss={tabsStyles}>
							{entities.map((entity) => (
								<StyledButton
									key={entity}
									appearance="default"
									onClick={() => onEntityChanged(entity)}
									isSelected={selectedEntityTab === entity}
								>
									{entity}
								</StyledButton>
							))}
						</Flex>
					</Flex>
				</Inline>
			)}
			<StatusTable thirdParty={thirdParty} />
		</>
	);
};
const tabHeaderStyles = xcss({
	marginTop: 'space.150',
	marginBottom: 'space.100',
});

const textStyles = xcss({
	minWidth: '70px',
	fontSize: '12px',
	fontWeight: 500,
	paddingTop: 'space.050',
	paddingBottom: 'space.075',
});

const tabContentStyles = xcss({
	maxWidth: '100%',
	minWidth: '75%',
	flexGrow: 1,
});

const tabsStyles = xcss({
	overflow: 'auto',
	padding: 'space.050',
	paddingBottom: 'space.075',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledButton = styled(Button)<ButtonProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		borderRadius: '20px',
		textTransform: 'capitalize',
	},
});
